import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const tint = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-700',
  'bg-accent-100 text-accent-700',
  'bg-primary-100 text-primary-700',
  'bg-secondary-100 text-secondary-700',
];

export default function CategoryGrid() {
  return (
    <section
      id="categories"
      className="w-full scroll-mt-24 border-y border-background-200 bg-background-100 px-4 py-12 md:px-8 md:py-16"
    >
      <div className="mb-8 text-center">
        <span className="text-sm font-bold text-secondary-700">主题分类</span>
        <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
          六个栏目，总有一款瓜戳中你
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
          每个栏目都有自己的脾气：有的负责让你笑出声，有的负责让你反复确认自己是不是看错了。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat, idx) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
          >
            <div className="flex items-center justify-between">
              <span className={`flex h-12 w-12 items-center justify-center rounded-lg text-2xl ${tint[idx % tint.length]}`}>
                <i className={cat.icon} aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-200">{String(idx + 1).padStart(2, '0')}</span>
            </div>
            <h3 className="mt-4 flex items-center gap-1 font-heading text-xl text-foreground-950">
              {cat.name}
              <i className="ri-arrow-right-up-line text-primary-500 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true"></i>
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
            <span className="mt-4 text-xs text-foreground-500">已收录 {cat.count} 篇</span>
          </Link>
        ))}
      </div>
    </section>
  );
}